<template>
  <div v-if="router">
    <div
      v-if="
        (router === 'normal' && $auth.policies['view-head-fee-list'] && !isSubFee) ||
          (router === 'priority' && $auth.policies['view-dedution-list'] && !isSubFee) ||
          (router === 'normal' && $auth.policies['view-arrear-fee-list'] && isSubFee) ||
          (router === 'priority' && $auth.policies['view-refund-fee-list'] && isSubFee)
      "
      class="pa-4"
    >
      <Breadcrumbs
        :headline="headFee.title"
        :link="[
          { text: 'Tài chính', href: '/#' },
          { text: `${titleType.charAt(0).toUpperCase() + titleType.slice(1)}`, href: `/${$route.name}` },
          { text: `${headFee.title}`, disabled: true }
        ]"
      />
      <HeadFeeDetail :headFee="headFee" />
      <v-card outlined>
        <div class="d-flex justify-end align-end mx-6">
          <v-btn
            v-if="
              ($auth.policies['add-group-dedution'] && router === 'priority' && !isSubFee) ||
                (router === 'normal' && $auth.policies['add-group-head-fee'] && !isSubFee) ||
                ($auth.policies['add-group-refund-fee'] && router === 'priority' && isSubFee) ||
                (router === 'normal' && $auth.policies['add-group-arrear-fee'] && isSubFee)
            "
            class="my-6"
            depressed
            color="primary"
            @click="createDialog = !createDialog"
          >
            <v-icon left>add</v-icon>
            Thêm áp dụng
          </v-btn>
        </div>
        <HeadFeeDetailGroupFee :headFee="headFee" />
      </v-card>
      <div class="d-flex justify-center align-end mx-6">
        <v-btn
          v-if="
            ($auth.policies['delete-dedution'] && router === 'priority' && !isSubFee) ||
              ($auth.policies['delete-head-fee'] && router === 'normal' && !isSubFee) ||
              ($auth.policies['delete-refund-fee'] && router === 'priority' && isSubFee) ||
              (router === 'normal' && $auth.policies['delete-arrear-fee'] && isSubFee)
          "
          class="my-6 v-btn--outlined v-size--small error--text pa-4 font-weight-bold"
          depressed
          @click="removeHeadFee"
        >
          {{ `Xóa ${titleType}` }}
        </v-btn>
      </div>
      <headFeeDetailGroupFeeNewDialog :state="createDialog" :headfee="headFee" style="margin: 0 20px" />
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import Breadcrumbs from '@/components/layout/Breadcrumbs'
import HeadFeeDetail from '@/modules/tuitionFee/head-fee/headFeeDetail.vue'
import HeadFeeDetailGroupFee from '@/modules/tuitionFee/head-fee/headFeeDetailGroupFee.vue'
import headFeeDetailGroupFeeNewDialog from '@/modules/tuitionFee/head-fee/headFeeDetailGroupFeeNewDialog.vue'
import Page403 from '@/views/Page403.vue'
export default {
  components: {
    Breadcrumbs,
    HeadFeeDetail,
    HeadFeeDetailGroupFee,
    headFeeDetailGroupFeeNewDialog,
    Page403
  },
  data() {
    return {
      dialog: false,
      createDialog: false
    }
  },
  async created() {
    this.$loading.active = true
    await this.reset()
    if (this.$route.params.id) {
      await this.fetchHeadFee(this.$route.params.id)
      await this.getGroupHeadFeeByHeadFee(this.$route.params.id)
    }
    this.$loading.active = false
    this.setRouter(this.pathName)
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['headFee', 'router', 'isSubFee', 'groupHeadFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết ', '')
    },
    pathName() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', [
      'fetchHeadFee',
      'getGroupHeadFeeByHeadFee',
      'deleteHeadFee',
      'setRouter',
      'reset'
    ]),
    async removeHeadFee() {
      this.$dialog.confirm({
        title: `Xác nhận xóa ${this.titleType}?`,
        text: `<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá ${this.titleType}?</div>`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.deleteHeadFee({ id: this.headFee.id, type: this.router })
            this.$alert.deleteSuccess(this.titleType)
            this.$router.push({ path: `/${this.$route.name}` })
            this.$loading.active = false
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: `Không thể xóa ${this.titleType}. Vui lòng thử lại`
            })
          }
        }
      })
    }
  },
  watch: {
    pathName() {
      this.setRouter(this.pathName)
    }
  }
}
</script>
